module.exports = __webpack_public_path__ + "static/media/logo_shb.be63b512.svg";